export default __webpack_public_path__ + "static/media/counterweight.841090f5.png";